import React from 'react';
import { Skeleton } from 'antd';
import { HeartFilled, HeartOutlined, EditOutlined, DeleteOutlined, TeamOutlined } from '@ant-design/icons';
import { formatContactDisplay, getGroupMemberCount, getGroupMembers } from '../../hooks/useComposeContacts';
import '../../styles/compose/ContactsDropdown.css';

const ContactsDropdown = ({ contacts, selectedTags, field, onSelect, onAddFavorite, onRemoveFavorite, onEdit, onDelete, isLoading, t }) => {
    if (isLoading) {
        return (
            <div className="contacts-dropdown-container contacts-dropdown-loading">
                {[1, 2, 3].map(i => (
                    <div key={i} className="contact-item-skeleton">
                        <Skeleton active paragraph={false} title={{ width: '60%' }} />
                    </div>
                ))}
            </div>
        );
    }

    if (!contacts || contacts.length === 0) {
        return (
            <div className="contacts-dropdown-empty">
                {t ? t('contacts.noContactsFound') : 'No contacts found'}
            </div>
        );
    }

    return (
        <div className="contacts-dropdown-container">
            {contacts.map(contact => {
                const isGroup = contact._type === 'group';
                const displayName = formatContactDisplay(contact);
                const isFavorite = contact.contact_type === 'favorite';

                const emailsInGroup = isGroup ? getGroupMembers(contact) : (contact.email ? [contact.email] : []);
                const memberCount = isGroup ? getGroupMemberCount(contact) : 0;
                const selectedCount = emailsInGroup.filter(e => selectedTags.includes(e)).length;
                const fullySelected = emailsInGroup.length > 0 && selectedCount === emailsInGroup.length;
                const partiallySelected = isGroup && emailsInGroup.length > 1 && selectedCount > 0 && selectedCount < emailsInGroup.length;

                return (
                    <div
                        key={contact.id || contact.email}
                        onClick={() => onSelect(contact.email, field, isGroup)}
                        className={`contact-item ${fullySelected ? 'contact-item-selected' : ''}${partiallySelected ? ' contact-item-group-partial' : ''}`}
                    >
                        <span className="contact-item-content">
                            {isGroup
                                ? <TeamOutlined className="contact-item-group-icon" />
                                : isFavorite && <HeartFilled className="contact-item-favorite-icon" />
                            }
                            <span className="contact-item-name">{displayName}</span>
                            {isGroup && memberCount > 0 && (
                                <span className="contact-item-group-meta">
                                    <span className="contact-item-count-badge">{memberCount}</span>
                                    <span className="contact-item-group-members">
                                        {emailsInGroup.slice(0, 3).join(', ')}
                                        {emailsInGroup.length > 3 && ` +${emailsInGroup.length - 3}`}
                                    </span>
                                </span>
                            )}
                        </span>
                        <span className="contact-item-actions" onClick={e => e.stopPropagation()}>
                            <span
                                className="contact-item-action contact-item-action-favorite"
                                onClick={e => isFavorite ? onRemoveFavorite(contact, e) : onAddFavorite(contact, e)}
                            >
                                {isFavorite ? <HeartFilled /> : <HeartOutlined />}
                            </span>
                            <span className="contact-item-action contact-item-action-edit" onClick={e => onEdit(contact, e)}>
                                <EditOutlined />
                            </span>
                            <span className="contact-item-action contact-item-action-delete" onClick={e => onDelete(contact, e)}>
                                <DeleteOutlined />
                            </span>
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default ContactsDropdown;
